import Resource from './Resource';

export default class Student extends Resource{
	constructor( options = {} ) {
		let {
			query = {},
			data = []
		} = options;

		let config = { 
			route: 'students',
			query: query,
			data: data
		};
		super(config);
		return this;
	}

	get() {
		return this.request();
	}

	post() {
		return this.request('post');
	}
}
